module.exports = __webpack_public_path__ + "static/media/plate-emoji.01bd06d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/plate-emoji.png
// module id = 170
// module chunks = 0